import React, {useCallback, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import * as actionCreators from '../../../store/actions';
import {BASE_URL_TYPE} from '../../../api/axios';

export default function CheckoutSuccess({sessionId = null}) {
  // Set dispatchers.
  const dispatch = useDispatch();
  const setDownloadProgress = useCallback(data => dispatch(actionCreators.setDownloadProgress(data)), [dispatch]);

  useEffect(() => {
    if (sessionId) {
      const settings = {
        reportName: '_Property Zoning Report',
        jobId: sessionId,
        getFileAsInitial: true,
      };
      setDownloadProgress({url: `${BASE_URL_TYPE.PROPZONE}/generate-pdf`, params: settings});
    }
  }, [sessionId, setDownloadProgress]);

  return (
    <div className="checkout-success-container" style={{padding: '20px', textAlign: 'center'}}>
      <div>
        <div style={{fontSize: '48px', color: '#28a745', marginBottom: '20px'}}>✓</div>
        <h2 style={{color: '#28a745', marginBottom: '20px'}}>Payment Successful!</h2>
        <p style={{fontSize: '16px', color: '#6c757d', marginBottom: '30px'}}>
          Thank you for your purchase. Your payment has been processed successfully. The PDF report will be
          automatically downloaded to your browser and sent to the email you provided on checkout.
        </p>
      </div>
    </div>
  );
}

CheckoutSuccess.propTypes = {
  sessionId: PropTypes.string,
};
